import { FORM_MODES } from 'config/formModes';
import { CAMPAIGN_DIMENSION } from 'services/campaignDimension';
import { MODULE_NAME } from '../config';
import { ENTITY } from '../config/routes/entity';
import { CREATIVE_LIBRARY_ROUTE_PATH } from '../config/routes/routeTypes';
import { generateFormPath } from './generateFormPath';

export const generateLibraryCreativeEditorPath = ({
    accountId,
    mode = FORM_MODES.EDIT,
    dimension = CAMPAIGN_DIMENSION.SPONSORED,
    creativeId,
}) =>
    generateFormPath(CREATIVE_LIBRARY_ROUTE_PATH, {
        accountId,
        entity: ENTITY.CREATIVE,
        mode,
        dimension,
        creativeId,
        module: MODULE_NAME,
    });
